module.exports = {"OFFER_DETAILS":"Offer details","OFFER_STATS":"Offer statistics","CLAIMS_STATS":"Claims","TRX_STATS":"Transactions<br><small>#conversionRate#% of claimants</small>","SALES_STATS":"Total sales","AVERAGE_PER_CLIENT_STATS":"Average spend per client","CASHBACK_STATS":"Total cashback","CASHBACK_STATS_TOOLTIP":"Total cashback amount including taxes","MARKETING_FEES_STATS":"Total marketing fees (before taxes)","MARKETING_FEES_STATS_TOOLTIP":"Total marketing fees before taxes"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/deal.json
// module id = 348
// module chunks = 8